var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.653-.059l-.53.528-8.569 8.54-2.108 4.568 4.52-2.167 9.096-9.067L11.653-.06zm0 2.118l.284.283-7.851 7.825-.533.256.249-.54 7.851-7.824z",
    fill: "#1253FA"
  })));
}
export default SvgIconsEdit;